module.exports = __webpack_public_path__ + "img/platform-activities-network-security.af81d45e.png";